import React from "react";
import "./Loader.css"; // Import CSS
import config  from "../config";

const Loader = () => {
  return (
    <div className="loader-container">
      <img src={config.loader} alt="Loading..." className="loader-image" />
    </div>
  );
};

export default Loader;
